// RecentLabResultsCard.jsx

import React, { useEffect, useState } from "react";
import { GiTestTubes } from "react-icons/gi";
import labicon from "../../../assets/images/labicon.svg";
import moment from "moment";
import axiosInstance from "../../../axios/axios";
import { Decrypt_Value } from "../../../MiddleWare/EncryptDecrypt";

const RecentLabResultsCard = ({ onExportData }) => {
  const dtFormat = localStorage.getItem("dateFormat") || "MM/DD/YYYY";

  const [labResults, setLabResults] = useState([]);

  const BUFFER_LIMIT = 5;

  const getPatientIdFromUrl = () => {
    const pathSegments = window.location.pathname.split("/");
    return pathSegments[pathSegments.length - 1];
  };

  // ── Fetch Recent Lab Results ──
  const fetchInitialResults = async () => {
    const patientId = getPatientIdFromUrl();

    if (!patientId) return;

    try {
      const res = await axiosInstance.get(
        `/vozo/get/lab/results?patient_id=${patientId}&limit=${BUFFER_LIMIT}&offset=0`,
      );

      const result = Decrypt_Value(res.data, "vozo");

      const data = Array.isArray(result.data) ? result.data : [];

      setLabResults(data);

      if (onExportData) {
        onExportData(
          data.map((item) => {
            const selectedParam =
              item.parameters?.find(
                (param) => param.interpretation === "High Risk",
              ) ||
              item.parameters?.find(
                (param) => param.interpretation === "Moderate",
              ) ||
              item.parameters?.find(
                (param) => param.interpretation === "Low Risk",
              ) ||
              item.parameters?.[0];

            return {
              testName: item.testName || "-",

              interpretation: selectedParam
                ? `${selectedParam.resultValue || "—"} - ${
                    selectedParam.name || "—"
                  }`
                : "—",

              status:
                selectedParam?.interpretation ||
                item.parameterInterpretation ||
                "Normal",

              resultDate: item.resultDate || "-",
            };
          }),
        );
      }
    } catch (error) {
      console.error("Failed to fetch lab results:", error);
      setLabResults([]);
    }
  };

  useEffect(() => {
    fetchInitialResults();
  }, []);

  const interpretationBadgeClass = (val) => {
    switch (val) {
      case "High Risk":
        return "inactive-status";

      case "Moderate":
        return "warning-status";

      case "Low Risk":
        return "active-status";

      default:
        return "active-status";
    }
  };

  return (
    <div className="care-summary-card">
      <div className="care-summary-title-wrap">
        {/* <labicon className="care-summary-main-icon" /> */}
        <img
          src={labicon}
          style={{ height: "25px", width: "25px" }}
          className="care-summary-main-icon"
        />

        <h3 className="care-summary-title">Recent Lab Results</h3>
      </div>

      <div className="care-summary-body">
        {labResults.length > 0 ? (
          labResults.slice(0, 3).map((item, index, arr) => (
            <div
              key={item.id || index}
              className={`care-summary-row ${
                index !== arr.length - 1 ? "care-summary-border" : ""
              }`}
            >
              <div className="care-summary-content">
                <div className="care-summary-heading">
                  {item.testName || "—"}
                </div>

                <div className="care-summary-subtext dark-sub">
                  {item.parameters?.length > 0
                    ? (() => {
                        const selectedParam =
                          item.parameters.find(
                            (param) => param.interpretation === "High Risk",
                          ) ||
                          item.parameters.find(
                            (param) => param.interpretation === "Moderate",
                          ) ||
                          item.parameters.find(
                            (param) => param.interpretation === "Low Risk",
                          );

                        return selectedParam
                          ? `${selectedParam.resultValue || "—"} - ${
                              selectedParam.name || "—"
                            }`
                          : "—";
                      })()
                    : "—"}
                </div>

                <div className="care-summary-subtext">
                  Signed Date:{" "}
                  {item.resultDate
                    ? moment(item.resultDate).format("MMM DD, YYYY")
                    : "—"}
                </div>
              </div>

              <div
                className={`care-summary-status-wrap ${interpretationBadgeClass(
                  item.parameterInterpretation,
                )}`}
              >
                <span className="care-summary-status-dot"></span>

                <span className="care-summary-status-text">
                  {item.parameterInterpretation || "Normal"}
                </span>
              </div>
            </div>
          ))
        ) : (
          <div className="care-summary-subtext">
            No recent lab results Added
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(RecentLabResultsCard);
